import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../../config.js';
import '../../components/Footer.js';
import { infrastructure, moduleLoader } from '../../infrastructure.js';

/**
 * @returns {TemplatedResult}
 */
export default function renderFooter() {
  moduleLoader.loadModule(config.francescaWidgetUrl);

  return html` <osk-footer-wrapper .infrastructure=${infrastructure}></osk-footer-wrapper> `;
}
